const styles = {
  contentBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    // border: '1px dashed black',
  },
};

export default styles;